import { EmailTemplateBlock } from '@/communications/templates/models/email-template-block';
import { AbstractRepository } from '@/repositories/abstract-repository';

export class EmailTemplateBlocksRepository extends AbstractRepository<EmailTemplateBlock> {
    readonly endpoint = 'communications/templates/emails/blocks';
}
